// user
import { useEffect, useState } from "react";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { UsersStats } from "../../services/srvc-store-realm";

import { Row, Col } from 'antd';

const statisticsList = [
  {name: 'collections', code:'store', nmbr: 0, live: 0, actv: true},
  {name: 'media', code:'media', nmbr: 0, live: 0, actv: true},
  {name: 'tokens', code:'tokens', nmbr: 0, live: 0, actv: true},
  {name: 'network', code:'network', nmbr: 0, live: 0, actv: true}
]

export default function UserStatisticsModule() {

  const usxx = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();


  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(
    statisticsList
  )

  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        const result = await UsersStats({
          data: {user: asset.usid},
          user: asset.usid
        })
        // console.log (result)
        setData(data.map(item => ['store', 'media'].includes(item.code)
          ? {...item, nmbr: result.data[item.code]}
          : item ))
        // setData(result.data.store)

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  return (
    <>

      <Row className="m-0 p-0" gutter={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
      {data && data.map((item, i) => (item.actv ?
        <Col className="" xs={{span:12}} md={{span:6}} key={i}>

          <div className="back-color-wite border p-3 py-2 mb-1 rounded-wd">
            <p className="text-color-tone text-small m-0">{item.name.toUpperCase()}</p>
            <p className="m-0" style={{fontSize:'1.5rem'}}>{item.nmbr}</p>
          </div>

        </Col>
      : ''))}
      </Row>

    </>
  );

}